(ns hai.ui.components.tags
  "Shared tag UI used by both the web-app and the browser extension: `chip`, how
   a tag renders — composing [[hai.ui.components.chip/entity-chip]] — and
   `with-hash`, its `#`-prefixed display name. Purely presentational — the chip
   takes `:label` and `:on-remove` and emits hiccup, so each surface supplies its
   own remove behaviour (a re-frame dispatch on the web-app, an atom swap in the
   sidebar)."
  (:require
   [clojure.string :as str]
   [hai.ui.components.chip :as chip-ui]))

(defn with-hash
  "Display form of a tag name — always one leading `#`, no doubling."
  [s]
  (str "#" (str/replace (or s "") #"^#+" "")))

(defn chip
  "A tag as a removable chip: label plus, when `on-remove` is given, the divided
   remove × cell."
  [{:keys [label on-remove]}]
  [chip-ui/entity-chip
   {:label        label
    :remove-label "Remove tag"
    :on-remove    on-remove}])
